var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vgs-toggle",class:_vm.get_class,attrs:{"data-allow-toggle":""}},[_c('div',{staticClass:"toggle-content mobileFilter"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }